import "../Lightcast.scss";
import translate from "@/i18n/translate";
import { useIntl } from "react-intl";
import { WmChart, WmChartSlice } from "@watermarkinsights/ripple-react";
import WidgetLoader from "@/features/common/elements/WidgetLoader";
import ApiError from "../../common/elements/ApiError";
import { IndustryOrOccupation, IndustriesChartProps } from "../Interface";

export interface BottomGrowingIndustriesProps {
  industries: null | IndustryOrOccupation[];
  loader: boolean;
  forHtml?: boolean;
}

export default function BottomGrowingIndustries({
  industries,
  loader,
  forHtml
}: BottomGrowingIndustriesProps) {
  function useGetPopoverTextLabel(changeVal: string) {
    return useIntl().formatMessage(
      {
        id: "app.bottomGrowingOccp.popoverTextLabel"
      },
      {
        changeJob: changeVal.toLocaleString()
      }
    );
  }

  const GetPopoverTextLabel = (changeVal: string) => {
    return useGetPopoverTextLabel(changeVal);
  };

  const chartLabel = useIntl().formatMessage({
    id: "app.bottomGrowingInd.bottomThreeGrowing"
  });

  return (
    <div className={forHtml ? "bottom-growing-industries" : "paper-card"}>
      <div className="header">
        <div className="info">
          <h3 className={forHtml ? "html-title" : "title"}>
            {translate("app.bottomGrowingInd.bottomThreeGrowing")}
          </h3>
          <p className={forHtml ? "html-desc" : "description -des"}>
            {translate("app.bottomGrowingInd.reviewBottomIndus")}
          </p>
        </div>
      </div>
      <div className="body">
        {industries && <IndustriesChart industries={industries} />}
        {loader && !industries && (
          <WidgetLoader
            loaderContainerClasses="loader"
            loaderClasses="content"
          />
        )}
        {!loader && !industries && <ApiError />}
      </div>
    </div>
  );
}

function useGetPopoverTextLabel(changeVal: string) {
  return useIntl().formatMessage(
    {
      id: "app.bottomGrowingOccp.popoverTextLabel"
    },
    {
      changeJob: changeVal.toLocaleString()
    }
  );
}
const GetPopoverTextLabel = (changeVal: string) => {
  return useGetPopoverTextLabel(changeVal);
};

const IndustriesChart = ({ industries }: IndustriesChartProps) => {
  const chartLabel = useIntl().formatMessage({
    id: "app.bottomGrowingInd.bottomThreeGrowing"
  });

  return (
    <WmChart
      label={chartLabel}
      labelPosition="none"
      chartType="bar6"
      valueFormat="amount"
      showGrid={true}
      labelWidth="120px"
      print-mode={true}
    >
      {industries.map((row: IndustryOrOccupation) => {
        return (
          <WmChartSlice
            key={row?.name}
            amount={String(row?.change)}
            legend={row?.name}
            popoverText={GetPopoverTextLabel(String(row?.change))}
            popoverTitle={row?.changePercentage}
          />
        );
      })}
    </WmChart>
  );
};
